import { sessionLocalStorage } from './sessionLocalStorage';

export const setAuthParamsToLocalStorage = async (params): Promise<void> =>
  sessionLocalStorage.create(params);
